<h1 class="soft-text-xl mt-2 mb-3 mr-2 ml-2">Belegvermerk</h1>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="c row no-wrap center-v p-2 border-box">
    <soft-multiline-input
      [placeholder]="'Belegvermerk'"
      [lines]="4">
    </soft-multiline-input>
  </div>
  <div class="c row space-between no-wrap center-v p-2">
    <button class="soft-button soft-button-secondary custom-button mr-2" (click)="close(null)">Abbrechen</button>
    <button class="soft-button custom-button ml-2" type="submit" [disabled]="form.invalid">Speichern</button>
  </div>
</form>
